// extracted by mini-css-extract-plugin
module.exports = {"bg1":"style_bg1__ta1Ag","bg2":"style_bg2__Sr0_D","bg3":"style_bg3__tWU9D","card":"style_card__kb5tr"};